import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { ILogDespacho, IQueryParam, IPopulate } from 'modelos/src';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { HelperService } from '../../../../../auxiliares/servicios/helper.service';
import { IColumnas } from '../../../../../auxiliares/tabla/tabla.component';
import { IFiltroTabla } from '../../../../../auxiliares/tabla/filtro/filtro.component';
import { Lista2Service } from '../../../../../auxiliares/servicios/lista2.service';
import { ClienteJerarquiaService } from '../../../../../auxiliares/servicios/cliente-jerarquia.service';

@Component({
  selector: 'app-logs-despachos',
  templateUrl: './logs-despachos.component.html',
  standalone: false,
})
export class LogsDespachosComponent implements OnInit, OnDestroy {
  private clienteJerarquia = inject(ClienteJerarquiaService);
  private lista2 = inject(Lista2Service);
  helper = inject(HelperService);
  private navigator = inject(Router);
  private route = inject(ActivatedRoute);

  //// Tabla nueva
  public name = 'LogsDespachosComponent';
  public logsDespachos?: ILogDespacho[];
  public totalCount = 0;
  public columnas?: IColumnas<ILogDespacho>[];
  //
  public logsDespachos$?: Subscription;

  // FILTROS
  public cliente: IFiltroTabla = {
    filter: {
      field: 'idCliente',
    },
    label: 'Cliente',
    tipo: 'cliente-selector',
  };
  // Cliente en cuya jerarquía cuelga la entidad: el cliente elegido y toda su
  // descendencia.
  public ancestro: IFiltroTabla = {
    filter: {
      field: 'idsAncestros',
      incluirPropio: true,
    },
    label: 'En la jerarquía de',
    tipo: 'cliente-selector',
  };
  public filtros: IFiltroTabla[] = [];
  private populate: IPopulate = {
    path: 'cliente',
    select: 'nombre',
  };

  public query: IQueryParam = {
    populate: JSON.stringify(this.populate),
    sort: '-fechaCreacion',
    page: 0,
    limit: +this.helper.getPageSize(this.name),
    includeChildren: true,
    childrenLevel: 0,
  };

  public async listar(): Promise<void> {
    this.logsDespachos$?.unsubscribe();
    this.logsDespachos$ = this.lista2
      .logDespachos(this.query, 30)
      .subscribe((data) => {
        this.totalCount = data.totalCount;
        this.logsDespachos = data.datos;
      });
  }

  // Acciones
  public async crear() {
    this.navigator.navigate(['crear'], { relativeTo: this.route });
  }
  // Tabla
  private setColumnas() {
    this.columnas = [
      {
        header: {
          label: 'Fecha de creación',
          sortable: true,
          sort: 'fechaCreacion',
        },
        row: {
          fecha: (dato) => dato.fechaCreacion,
          hace: true,
        },
      },
      {
        header: {
          label: 'Fecha',
          sortable: true,
          sort: 'fecha',
        },
        row: {
          fecha: (dato) => dato.fecha,
        },
      },
      {
        header: {
          label: 'ID de vehículo externo',
        },
        row: {
          field: 'idExternoVehiculo',
          noData: 'Sin ID',
        },
      },
      {
        header: {
          label: 'ID de recorrido externo',
        },
        row: {
          field: 'idExternoRecorrido',
          noData: 'Sin ID',
        },
      },
      {
        header: {
          label: 'ID de chofer externo',
        },
        row: {
          field: 'idExternoChofer',
          noData: 'Sin ID',
        },
      },
      {
        header: {
          label: 'Cliente',
        },
        row: {
          html: (dato) => this.clienteJerarquia.htmlNombre(dato.cliente),
          tooltip: (dato) =>
            this.clienteJerarquia.tooltipJerarquia(dato.cliente),
          noData: 'Sin cliente',
        },
      },
    ];
  }

  // Hooks

  async ngOnInit() {
    if (HelperService.getTipoCliente() !== 'Final') {
      this.filtros.push(this.cliente);
      this.filtros.push(this.ancestro);
    }
    this.setColumnas();
    await this.listar();
  }

  ngOnDestroy() {
    this.logsDespachos$?.unsubscribe();
  }
}
